import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/system';
import bgimage from "../../../assets/updatedBannerImage/REEF-49.jpg";

const Background = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: '85vh',
  width: '100%',
  backgroundImage: `url(${bgimage})`,
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    height: '60vh', // smaller height on mobile
  },
}));

const InvolvedBox = styled(Box)(({ theme }) => ({
  backgroundColor: 'rgba(0, 0, 0, 0.85)',
  padding: theme.spacing(3, 5),
  borderLeft: '4px solid #D0F365',
  borderBottom: '4px solid #D0F365',
  display: 'inline-block',
  position: 'absolute',
  right: theme.spacing(8),
  top: '50%',
  transform: 'translateY(-50%)',
  maxWidth: 400,

  [theme.breakpoints.down('sm')]: {
    position: 'static',  // Remove absolute on mobile
    transform: 'none',
    margin: theme.spacing(2),
    maxWidth: '90%',
    borderLeft: '4px solid #D0F365',
    borderBottom: '4px solid #D0F365',
    padding: theme.spacing(2, 3),
  },
}));

const Donate = () => {
  return (
    <Background>
      <InvolvedBox>
        <Typography
          variant="h4"
          sx={{
            color: '#fff',
            fontWeight: 700,
            fontSize: { xs: '1.8rem', sm: '2.5rem',fontFamily: "Montserrat, sans-serif", }, // smaller font on mobile
          }}
        >
          Get Involved
        </Typography>
      </InvolvedBox>
    </Background>
  );
};

export default Donate;
